import { Container, Button } from "@mui/material";
import React, { useEffect, useState } from "react";
import HeaderBreadcrumbs from "src/components/HeaderBreadcrumbs";
import useSettings from "src/hooks/useSettings";
import { PATH_DASHBOARD } from "src/routes/paths";
import { styled } from "@mui/material/styles";
import CloudUploadIcon from "@mui/icons-material/CloudUpload";
import {
  getAirlineExcelApi,
  uplodaAirlineFileApi,
} from "src/Api/Services/AirlineUploadExcelApi";
import useLoadingSnackbar from "src/components/CustomComponents/useLoadingSnackbar";
import { useSnackbar } from "notistack5";
import AirlineUploadExcelTable from "./AirlineUploadExcelTable";
import UpdateAirlineUpload from "./UpdateAirlineUpload";
import CustomModalComp from "src/components/CustomComponents/CustomModalComp";
import SearchOffIcon from "@mui/icons-material/SearchOff";
const AirlineUploadRoute = () => {
  const { enqueueSnackbar } = useSnackbar();
  const {
    showLoadSnackbar,
    closeLoading,
    loading: fileLoading,
  } = useLoadingSnackbar();
  const [fileData, setFileData] = useState({});
  const [show, setShow] = useState(false);
  const [editData, setEditData] = useState({});
  const [page, setPage] = useState(1);
  const VisuallyHiddenInput = styled("input")({
    clip: "rect(0 0 0 0)",
    clipPath: "inset(50%)",
    height: 1,
    overflow: "hidden",
    position: "absolute",
    bottom: 0,
    left: 0,
    whiteSpace: "nowrap",
    width: 1,
  });
  const { themeStretch } = useSettings();
  const fetchData = async () => {
    try {
      const { data } = await getAirlineExcelApi(page);
      setFileData(data || {});
    } catch (error) {}
  };
  const hadndleFileUpload = async (file) => {
    showLoadSnackbar("Please wait...");
    const formData = new FormData();
    formData.append("airlineExcel", file);
    try {
      const { data } = await uplodaAirlineFileApi(formData);
      enqueueSnackbar(data?.message || "Something went wrong", {
        variant: data?.status ? "success" : "error",
      });
      data?.status && fetchData();
      closeLoading();
    } catch (error) {}
  };
  useEffect(() => {
    fetchData();
  }, [page]);
  return (
    <>
      <Container maxWidth={themeStretch ? false : "xxxl"} spacing={1}>
        <HeaderBreadcrumbs
          heading="Airline Upload Excel"
          links={[
            { name: "Dashboard", href: PATH_DASHBOARD.root },
            {
              name: "Airline Upload Excel",
              href: PATH_DASHBOARD.farerule.airlineUpload,
            },
          ]}
        />
        <div className="text-center">
          <Button
            component="label"
            role={undefined}
            variant="contained"
            tabIndex={-1}
            startIcon={<CloudUploadIcon />}
            disabled={fileLoading}
          >
            Upload files
            <VisuallyHiddenInput
              type="file"
              onChange={({ target: { files } }) => hadndleFileUpload(files[0])}
              multiple
            />
          </Button>
        </div>
        {fileData?.data?.length > 0 ? (
          <AirlineUploadExcelTable
            editClick={(item) => {
              setShow(true);
              setEditData(item);
            }}
            fileData={fileData}
            fetchData={fetchData}
            page={page}
            nextPage={(page) => setPage(page)}
          />
        ) : (
          <div className="text-center mt-5">
            <SearchOffIcon fontSize="large" />
            No data found
          </div>
        )}
      </Container>
      <CustomModalComp
        show={show}
        onHide={() => setShow(false)}
        title={"Update Airline Details"}
        // backdrop={true}
      >
        <UpdateAirlineUpload
          editData={editData}
          fetchData={() => {
            setShow(false);
            fetchData();
          }}
        />
      </CustomModalComp>
    </>
  );
};

export default AirlineUploadRoute;
